import React from 'react';
import { useSelector } from 'react-redux';

import { Spot } from '@travel/icons/ui';
import { useTranslation } from '@travel/traveler-core/hooks';
import { IconText, StarRating } from '@travel/ui';
import { cx } from '@travel/utils';

import { Link } from 'core/universalRouter/Link';
import { getProviderGuestReview } from 'store/providerReview/selectors';

import styles from './providerInfo.module.scss';

type Props = {
  className?: string;
  /** String of URL to navigate to the main page */
  providerInfoUrl: string;
};

function ProviderInfo(props: Props) {
  const { provider } = useSelector(getProviderGuestReview);
  const starRatingLabel = provider?.starRating
    ? useTranslation({
        id: 'Traveler_Common.Alt.Star_Rating',
        data: { score: provider?.starRating },
      })
    : '';

  return (
    <div
      data-locator-id="ProviderInfo-5b3c451b-1582-4b0a-9b2c-cf3b4aedff63"
      className={cx(styles.wrapper, props.className)}
    >
      {Number(provider?.starRating) > 0 && (
        <StarRating
          rating={provider?.starRating}
          size={16}
          className={styles.starRating}
          ariaLabel={starRatingLabel}
        />
      )}
      <Link to={props.providerInfoUrl} data-testid="providerReview-providerInfo-Link">
        <h1 className={styles.title}>{provider?.name}</h1>
      </Link>
      {provider?.address && (
        <IconText
          className={styles.address}
          icon={<Spot size={16} />}
          text={`${provider.address?.addressLine}, ${provider.address.postCode}`}
          spaceBetween={4}
        />
      )}
    </div>
  );
}

export default ProviderInfo;
